import React, { useEffect, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import "./ReservaFormularioInicial.css"
import MiniRoomTypeCard from "src/shared/components/data-display/tooltip/MiniRoomTypeCard/MiniRoomTypeCard"
import { Button, InputText } from "src/shared/components/forms"
import Counter from "src/shared/components/forms/counter/Counter"
import { useForm, Controller } from "react-hook-form"
import { defaultValues, FormValues, LimiteReservaModal } from "./reserva-formulario-inicial.types"
import { getKey } from "../../shared/helpers"
import Screen from "src/shared/components/layout/screen/Screen"
import InputTextSuggestions from "src/shared/components/forms/input-text-suggestions/InputTextSuggestions"
import iconHash from "src/shared/icons/iconHash"
import book2Fill from "src/shared/icons/book2Fill"
import AlertReservas from "./alerta-reservas-max"
import LoaderComponent from "src/shared/components/layout/loader/Loader"
import {
    EstatusGrupoTarifa,
    EstatusTarifa,
    ModalidadGrupoTarifa,
    OrigenRservas,
    Tarifa,
    useConfiguracionEstanciaQuery,
    useGetExperienciasLazyQuery,
    useGetTiposHabitacionQuery,
    useTarifasLazyQuery,
} from "src/gql/schema"
import { useProfile } from "src/shared/hooks/useProfile"
import { getLimiteReserva } from "src/pages/reservaciones/helpers/limiteReserva"
import { v4 as uuid } from "uuid"
import DatePicker from "src/shared/components/forms/date-picker/DatePicker"
import { capitalize } from "src/shared/helpers/capitalize"
import useEscapeKey from "src/shared/hooks/useEscapeKey"
import MultipleSelectDropdown from "src/shared/components/forms/MultipleSelectDropdown/MultipleSelectDropdown"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { addDays } from "src/shared/helpers/addDays"
import Tooltip from "src/shared/components/data-display/tooltip/Tooltip"
import Icon from "src/shared/icons"
import { sum } from "src/shared/helpers/calculator"
import { useMotorTarifas, useOpcionesTarifas } from "src/shared/hooks/useMotorTarifas"
import CancelReservaModal from "../../shared/components/CancelReservaModal/CancelReservaModal"
import useSnackbar from "src/shared/hooks/useSnackbar"

const ReservaFormularioInicial = () => {
    const { hotel_id } = useProfile()
    const [origenReserva] = useState(
        Object.keys(OrigenRservas).map((key) => {
            return key === "Telefono" ? "Teléfono" : key === "Recepcion" ? "Recepción" : key
        })
    )
    const location = useLocation()
    const goBackState = location.state
    const reserva = goBackState?.reservaEdit !== undefined ? goBackState?.reservaEdit : goBackState

    const [numMaxPersonas, setNumMaxPersonas] = useState<number>(0)
    const [alerta, setAlerta] = useState<LimiteReservaModal>({ visible: false, date: "" })
    const [calendarLoad, setCalendarLoad] = useState<boolean>(false)
    const [loader, setLoader] = useState<boolean>(false)
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false)

    const navigate = useNavigate()
    const { nowHotel: dateHotel, getStartOfHotelDayISO, getHotelDateParts } = useFormatDate()
    // Compara un día seleccionado en el DatePicker (semántica local, sin zona) contra "ahora",
    const isSameHotelDay = (pickerDate?: Date) => {
        if (!pickerDate) return false
        const todayHotel = getHotelDateParts(dateHotel)
        return (
            pickerDate.getFullYear() === todayHotel.year &&
            pickerDate.getMonth() === todayHotel.month &&
            pickerDate.getDate() === todayHotel.day
        )
    }

    const {
        control,
        watch,
        handleSubmit,
        getValues,
        reset,
        setValue,
        formState: { errors, isDirty },
        setError,
    } = useForm<FormValues>({
        defaultValues,
    })

    const tipoDeHabitacion = watch("tipoDeHabitacion")
    const tarifasSelected: string[] = watch("tarifas") || []
    const tarifasAdicionalesSelected: string[] = watch("tarifasAdicionales") || []

    const valueNumPersonas = watch("cantidadPersonas")
    const valueNumPersonasExtra: number = watch("cantidadPersonasExtra") || 0
    const totalPersonas = valueNumPersonas + valueNumPersonasExtra
    const origen = watch("origenReserva")
    const fechaReserva = watch("fechaReserva")
    const reservaIdSaved = watch("reservaIdSaved")
    const folioSaved: number = watch("folioSaved") || 0
    const experienciasSaved = watch("experienciasSaved") || []
    const descuento = (Number(reserva?.descuento) || 0)
    const totalSaved = (reserva?.totalSaved) || 0
    const montoOriginal = totalSaved + descuento
    const valueMinNumPersonasExtra = reserva?.reservaIdSaved ? reserva?.cantidadPersonasExtra || 0 : 0

    const [origenFiltroVisual, setOrigenFiltroVisual] = useState<boolean>(true)

    const [getExperiencias, { data }] = useGetExperienciasLazyQuery({
        variables: { hotel_id: hotel_id },
    })

    const [getTarifas] = useTarifasLazyQuery()

    const [tarifasList, setTarifasList] = useState<Tarifa[]>([])

    const [habitacionesFiltradas, setHabitacionesFiltradas] = useState<any[]>([])

    const { data: tiposHabitacion } = useGetTiposHabitacionQuery({
        variables: { hotel_id: hotel_id },
    })

    const { data: configEstancia } = useConfiguracionEstanciaQuery({ variables: { hotel_id } })
    const personaExtraEnabled = configEstancia?.configuracion_estancia?.data?.personas_extra ?? true

    useEffect(() => {
        if (tiposHabitacion?.tipo_habitaciones?.length) {
            tiposHabitacion.tipo_habitaciones.forEach((tipo) => {
                if (!tipo.config_tipo_estancia?.reserva) return

                getTarifas({ variables: { tipo_habitacion_id: tipo.tipo_habitacion_id, hotel_id } }).then((d) => {
                    const tarifas = d?.data?.tarifas || []
                    const habitacionesConReserva = tarifas.filter(
                        (t) => !t.eliminado && t.estatus === EstatusTarifa.Activa && t.tipo_tarifa.includes("reserva") &&
                               (!t.grupo_tarifa || (!t.grupo_tarifa.eliminado && t.grupo_tarifa.estatus === EstatusGrupoTarifa.Activa))
                    )
                    if (habitacionesConReserva.length > 0) {
                        setHabitacionesFiltradas((prev) => [
                            ...prev,
                            { ...tipo, desactivar: false },
                        ])
                    }
                })
            })
        }
    }, [tiposHabitacion])

    useEffect(() => {
        if (getValues("tipoDeHabitacion").id === "" && hotel_id === "515e9f84-35f7-4d80-b4b7-b49c4bff4739") {
            setValue(
                "tipoDeHabitacion.id",
                tiposHabitacion?.tipo_habitaciones[0].tipo_habitacion_id || "19d9c96e-9689-4198-9a6e-67358663c8b0"
            )
            setValue("tipoDeHabitacion.nombre", tiposHabitacion?.tipo_habitaciones[0].nombre || "Sencilla")
            setValue("cantidadPersonas", tiposHabitacion?.tipo_habitaciones[0].personas_incluidas || 2)
            setNumMaxPersonas(tiposHabitacion?.tipo_habitaciones[0].personas_incluidas || 2)
        }

        if (tipoDeHabitacion.id) {
            getTarifas({ variables: { tipo_habitacion_id: tipoDeHabitacion?.id, hotel_id } }).then((d) => {
                const list =
                    (d?.data?.tarifas.filter((t) =>
                        !t.eliminado &&
                        t.estatus === EstatusTarifa.Activa &&
                        (!t.grupo_tarifa || (!t.grupo_tarifa.eliminado && t.grupo_tarifa.estatus === EstatusGrupoTarifa.Activa))
                    ) ?? []) as Tarifa[]

                const tarifasListFiltered = list.filter(({ tipo_tarifa = "" }) => tipo_tarifa.includes("reserva")) as Tarifa[]

                setTarifasList(tarifasListFiltered)
            })
        }
    }, [tipoDeHabitacion])

    const [personasExtraMax, setPersonasExtraMax] = useState(0)

    const fechasNormalizadas = fechaReserva.map((fecha) => {
        const nuevaFecha = new Date(fecha)
        nuevaFecha.setHours(0, 0, 0, 0)
        return nuevaFecha
    })

    const { opciones_tarifas_hotel, opciones_tarifas_adicionales } = useOpcionesTarifas({
        fechas: fechasNormalizadas,
        tarifas: fechasNormalizadas.length ? tarifasList : [],
    })

    useEffect(() => {
        setPersonasExtraMax(tarifasList.find((t) => t.tarifa_id === tarifasSelected[0])?.tipo_habitacion?.personas_extra_max || 0)
    }, [tarifasSelected])

    useEffect(() => {
        setValue("cantidadPersonasExtra", valueMinNumPersonasExtra)
    }, [tipoDeHabitacion])

    useEffect(() => {
        setValue("tarifas", defaultValues.tarifas)
        setValue("tarifasAdicionales", defaultValues.tarifasAdicionales)
    }, [tipoDeHabitacion.id, fechaReserva])

    useEffect(() => {
        if (!opciones_tarifas_hotel.length) return
        const baseTarifa = opciones_tarifas_hotel.find((o) => o.modalidad === "base")
        if (!baseTarifa) return
        const currentTarifas = getValues("tarifas") || []
        if (!currentTarifas.includes(baseTarifa.value)) {
            setValue("tarifas", [baseTarifa.value])
        }
    }, [opciones_tarifas_hotel])

    const maxPersonas = (num?) => {
        if (num) {
            setNumMaxPersonas(num)
        }
    }

    useEffect(() => {
        if (!reserva && !origen) {
            setValue("origenReserva", "Checkfront")
            setOrigenFiltroVisual(false)
        }
    }, [reserva, origen, origenFiltroVisual, setValue])

    useEffect(() => {
        if (!reserva || isDirty) {
            return
        }

        const tipoHabitacionFromBackState = tiposHabitacion?.tipo_habitaciones.find(
            (th) => th.tipo_habitacion_id === reserva?.tipoHabitacionId
        )

        const tipoHabitacionFromBackStateToField = {
            id: tipoHabitacionFromBackState?.tipo_habitacion_id || "",
            nombre: tipoHabitacionFromBackState?.nombre || "",
        }

        setValue("cantidadPersonas", reserva?.cantidadPersonas)
        setNumMaxPersonas(tipoHabitacionFromBackState?.personas_incluidas || 0)
        setValue("codigoReserva", reserva?.codigoReserva)
        setValue("fechaReserva", reserva?.fechaReserva)
        setValue("tipoDeHabitacion", tipoHabitacionFromBackStateToField)
        setValue("origenReserva", capitalize(reserva?.origenReserva))
        setValue(
            "experiencias",
            Array.from(
                new Set([...(reserva?.experiencias || []), ...(reserva?.experienciasSaved || [])].filter((id) => id))
            )
        )
        setValue("reservaIdSaved", reserva?.reservaIdSaved)
        setValue("folioSaved", reserva?.folioSaved)
        setValue("experienciasSaved", reserva?.experienciasSaved)
        setValue("nombreHuespedSaved", reserva?.nombreHuespedSaved)
        setValue("telefonoHuespedSaved", reserva?.telefonoHuespedSaved)
        setValue("emailHuespedSaved", reserva?.emailHuespedSaved)
        setValue("totalSaved", reserva?.totalSaved)
        setValue("pagosSaved", reserva?.pagosSaved)
        setValue("comentarioSaved", reserva?.comentarioSaved)
        setValue("habitacionId", reserva?.habitacionId)
        setValue("descuentoId", reserva?.descuentoId)
        setValue("descuento", reserva?.descuento || 0)
    }, [tiposHabitacion, reserva, data?.experiencias, isDirty])

    useEffect(() => {
        if (isDirty) return
        if (!reserva?.tarifasSeleccionadas?.length) return

        const tarifasSeleccionadas = reserva?.tarifasSeleccionadas?.map((t) => t.tarifa_id) ?? []

        const tarifaBase = tarifasList.find(
            (t) => t.grupo_tarifa?.modalidad === "base"
        )

        if (tarifaBase && !tarifasSeleccionadas.includes(tarifaBase.tarifa_id)) {
            tarifasSeleccionadas.push(tarifaBase.tarifa_id)
        }

        setValue("tarifas", tarifasSeleccionadas)
        setValue(
            "tarifasAdicionales",
            (reserva.tarifasAdicionalesSeleccionadas || []).map((t) => t.tarifa_id)
        )
        setValue("cantidadPersonasExtra", reserva.cantidadPersonasExtra || 0)
    }, [tarifasList])

    const [codigoReservaRequired, setCodigoReservaRequired] = useState(false)

    useEffect(() => {
        setCodigoReservaRequired(
            !(
                origen?.toLowerCase()?.trim() === OrigenRservas.Email ||
                origen?.toLowerCase()?.trim().slice(0, 3) === "tel" ||
                origen?.toLowerCase()?.trim().slice(0, 5) === "recep"
            )
        )
    }, [origen])

    useEffect(() => {
        reset({ ...getValues(), codigoReserva: "" })
    }, [codigoReservaRequired])

    useEffect(() => {
        getExperiencias()
    }, [])

    const hasTarifaDateOverlap = (
        startDateA?: string,
        endDateA?: string,
        startDateB?: string,
        endDateB?: string
    ): boolean => {
        if (!startDateA || !endDateA || !startDateB || !endDateB) return false

        return new Date(startDateA).getTime() <= new Date(endDateB).getTime() &&
           new Date(endDateA).getTime() >= new Date(startDateB).getTime()
    }

    const getUpdatedTarifasSelection = (
        selectedTarifaIds: string[],
        currentTarifaIds: string[],
        selectedTarifaId: string,
        tarifaOptions: any[]
    ) => {
        const selectedOption = tarifaOptions.find(i => i.value === selectedTarifaId)

        if (selectedOption?.modalidad === "base") {
            return selectedTarifaIds
        }

        if (selectedTarifaIds.includes(selectedTarifaId)) {
            return currentTarifaIds
        }

        const selectedTarifa = tarifasList.find(t => t.tarifa_id === selectedTarifaId)

        const overlappingTarifaIds = currentTarifaIds.filter(id => {
            if (id === selectedTarifaId) return false

            const option = tarifaOptions.find(o => o.value === id)
            if (!option || option.modalidad === "base") return false

            const currentTarifa = tarifasList.find(t => t.tarifa_id === id)

            return hasTarifaDateOverlap(
                selectedTarifa?.fecha_inicio,
                selectedTarifa?.fecha_final,
                currentTarifa?.fecha_inicio,
                currentTarifa?.fecha_final
            )
        })

        return currentTarifaIds.filter(id => !overlappingTarifaIds.includes(id))
    }

    const experienciasSelected: string[] = watch("experiencias") || []
    const tarifasSeleccionadas = tarifasList.filter(t => tarifasSelected.includes(t.tarifa_id))
    const tarifasAdicionalesSeleccionadas = tarifasList.filter(t => tarifasAdicionalesSelected.includes(t.tarifa_id))
    const tipoAlojamiento = tarifasSeleccionadas[0]?.tipo_alojamiento || "Hotel" 
    const fechaInicio = fechaReserva[0] ? getStartOfHotelDayISO(fechaReserva[0]) : ""
    const fechaFinal = fechaReserva[1]
        ? getStartOfHotelDayISO(addDays({ date: fechaReserva[1], days: -1 }))
        : fechaReserva[0] ? getStartOfHotelDayISO(fechaReserva[0]) : ""

    const { desglose_tarifas } = useMotorTarifas({
        tarifas: tarifasSeleccionadas,
        tarifas_adicionales: tarifasAdicionalesSeleccionadas,
        tipo: tipoAlojamiento,
        horas_extra: 0,
        personas_extra: valueNumPersonasExtra,
        hospedajes_extra: 0,
        fecha_inicio: fechaInicio,
        fecha_final: fechaFinal,
    })

    const costoTotalEditado = (() => {
        if (!fechaReserva?.length) return 0

        const costoEstancia = desglose_tarifas.reduce((acc, d) => acc + d.subtotal_hospedaje, 0)
        const costoPersonasExtraTotal = desglose_tarifas.reduce(
            (acc, d) => acc + Number(d.tarifa.costo_persona_extra || 0) * valueNumPersonasExtra * d.dias,
            0
        )
        const costoExperiencias = sum(
            experienciasSelected.map((id) => {
                const exp = data?.experiencias?.find((e) => e.experiencia_id === id)
                return exp?.precio || 0
            })
        )

        return sum([costoEstancia, costoPersonasExtraTotal, costoExperiencias])
    })()
    const { showSnackbar } = useSnackbar()

    const onBack = (): void => setIsCancelModalOpen(true)

    const onSubmit = (data: FormValues) => {
        const error_edition = reservaIdSaved && costoTotalEditado !== null && typeof totalSaved === "number" && costoTotalEditado < montoOriginal

        if (error_edition) {
            showSnackbar({
                title: "Error al editar",
                text: "El monto total actualizado debe ser igual o mayor al monto de la reserva original.",
                status: "error",
            })
            return
        }


        //Validación para mostrar una alerta cuando la reserva a editar tenga el estado de check-in
        const error_check_in = reserva && reserva?.estadoReserva && reserva?.estadoReserva === "check_in"

        if (error_check_in) {
            setError("fechaReserva", {
                type: "custom",
                message: "La estancia de la nueva reserva debe ser igual o mayor a la original",
            })
            return
        }

        const datesValidate =
            data.fechaReserva.length > 1
                ? {
                    fecha_inicial: getStartOfHotelDayISO(data.fechaReserva?.[0]),
                    fecha_final: getStartOfHotelDayISO(data.fechaReserva?.[1]),
                }
                : {
                    fecha_inicial: getStartOfHotelDayISO(data.fechaReserva?.[0]),
                    fecha_final: getStartOfHotelDayISO(addDays({ date: data.fechaReserva?.[0], days: 1 })),
                }

        setLoader(true)
        getLimiteReserva({
            fechas_reserva: datesValidate,
            hotel_id: hotel_id,
            tipo_habitacion_id: data.tipoDeHabitacion.id,
        })
            .then(({ data: response }) => {
                const res = response?.verificar_limite_reservas
                if (res?.alerta_por_limite_reservas) {
                    setAlerta({ visible: true, date: res?.fecha_conflicto })
                } else {
                    onSuccess(data)
                }
            })
            .catch(() => onSuccess(data))
            .finally(() => setLoader(false))
    }

    const onSuccess = (data: FormValues) => {
        const tarifasSeleccionadasObjs = data.tarifas
            .map((id) => tarifasList.find((t) => t.tarifa_id === id))
            .filter(Boolean) as Tarifa[]

        const tarifasAdicionalesSeleccionadasObjs = (data.tarifasAdicionales || [])
            .map((id) => tarifasList.find((t) => t.tarifa_id === id))
            .filter(Boolean) as Tarifa[]

        const adicionalTarifa = tarifasAdicionalesSeleccionadasObjs[0]
        const temporadaTarifa = tarifasSeleccionadasObjs.find(
            (t) => t.grupo_tarifa?.modalidad !== ModalidadGrupoTarifa.Base
        )
        const baseTarifa = tarifasSeleccionadasObjs.find(
            (t) => t.grupo_tarifa?.modalidad === ModalidadGrupoTarifa.Base
        ) || tarifasSeleccionadasObjs[0]

        const effectiveTarifa = adicionalTarifa || temporadaTarifa || baseTarifa

        const sendData = {
            fechaReserva: data.fechaReserva,
            tipoHabitacion: data.tipoDeHabitacion,
            cantidadPersonas: data?.cantidadPersonas,
            cantidadPersonasExtra: data.cantidadPersonasExtra,
            codigoReserva: data.codigoReserva,
            origenReserva: getKey(data.origenReserva),
            totalPersonas: data?.cantidadPersonas,
            tipoHabitacionId: data.tipoDeHabitacion?.id,
            habitacionId: data?.habitacionId,
            numMaxPersonas: numMaxPersonas,
            horaCheckIn: effectiveTarifa?.hora_checkin,
            horaCheckOut: effectiveTarifa?.hora_checkout,
            numPersonas: data?.cantidadPersonas,
            costoPersonaExtra: effectiveTarifa?.costo_persona_extra,
            experiencias: data?.experiencias,
            reservaIdSaved: data?.reservaIdSaved,
            folioSaved: data?.folioSaved,
            nombreHuespedSaved: data?.nombreHuespedSaved,
            telefonoHuespedSaved: data?.telefonoHuespedSaved,
            emailHuespedSaved: data?.emailHuespedSaved,
            experienciasSaved: data?.experienciasSaved,
            totalSaved: data?.totalSaved,
            pagosSaved: data?.pagosSaved,
            comentarioSaved: data?.comentarioSaved,
            estadoReserva: reserva?.estadoReserva,
            tarifasSeleccionadas: tarifasSeleccionadas,
            tarifasAdicionalesSeleccionadas: tarifasAdicionalesSeleccionadas,
            descuentoId: data?.descuentoId,
            descuento: data?.descuento,
        }

        const reservaIdSavedValue = data?.reservaIdSaved
        navigate(
            reservaIdSavedValue
                ? `/u/registro-reserva/huesped/${reservaIdSavedValue}`
                : `/u/registro-reserva/huesped`,
            { state: sendData }
        )
    }

    useEscapeKey({
        onEscape: () => {
            navigate("/u/reservaciones/table")
        },
    })

    const getYesterday = () => {
        // Día calendario en la zona del hotel (no la del dispositivo), menos un día.
        const todayHotel = getHotelDateParts(dateHotel)
        return new Date(todayHotel.year, todayHotel.month, todayHotel.day - 1)
    }

    return (
        <Screen
            title={reservaIdSaved ? `Edición de reservación - ${folioSaved}` : "Registro de reserva"}
            className="registro-reserva-screen"
            contentClassName="guest-screen"
            onClose={onBack}
            back={false}
            close={true}
        >
            <section className="registro-reservas">
                {reservaIdSaved && (
                    <div className="registro-reservas__form__monto">
                        <span>
                            Monto original de reserva: <strong>${montoOriginal}</strong>
                        </span>
                        <Tooltip
                            title={"Edición de reserva"}
                            description={"Puedes editar tu reserva siempre que el nuevo total sea igual o mayor a la reserva original"}
                            theme="dark"
                            placement="right-start"
                        >
                            <Icon
                                name={"infoToolTip"}
                                color="var(--primary)"
                                style={{
                                    marginLeft: 10,
                                    width: 18,
                                    height: 18,
                                }}
                            />
                        </Tooltip>
                    </div>
                )}
                <form className="registro-reservas__form" onSubmit={handleSubmit(onSubmit)}>
                    <div className="registro-reservas__formDate">
                        <Controller
                            name="fechaReserva"
                            control={control}
                            rules={{
                                required: true,
                                validate: (v) => v.length > 1 || (isSameHotelDay(v[0]) && v.length > 0),
                            }}
                            render={({
                                field: { onChange: onFieldChange, value: fieldValue },
                                formState: { errors },
                            }) => (
                                <DatePicker
                                    loading={calendarLoad}
                                    placeholder="Selecciona un periodo en el calendario"
                                    label="Fecha de reservación"
                                    inputClassName="add-gasto-input-fecha"
                                    isRange
                                    onReset={() => {
                                        onFieldChange([])
                                    }}
                                    disabledBeforeOrEqualDate={getYesterday()}
                                    onChange={(date) => {
                                        if (fieldValue.length === 0) {
                                            onFieldChange([date])
                                            return
                                        }
                                        if (date <= fieldValue[0]) {
                                            onFieldChange([date])
                                            return
                                        }
                                        if (fieldValue?.length === 2 && isSameHotelDay(date)) {
                                            onFieldChange([date])
                                            return
                                        }
                                        if (fieldValue?.length === 2) {
                                            onFieldChange([])
                                            return
                                        }
                                        onFieldChange([fieldValue[0], date])
                                    }}
                                    value={fieldValue}
                                    errorHintText={
                                        errors.fechaReserva
                                            ? errors.fechaReserva?.message || "Selecciona un periodo en el calendario"
                                            : ""
                                    }
                                />
                            )}
                        />
                    </div>
                    <div className="registro-reservas__form__room">
                        <div className="registro-reservas__form__room__dropdown">
                            <Controller
                                name="origenReserva"
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { onChange, value } }) => (
                                    <InputTextSuggestions
                                        suggestionsListWidth="340px"
                                        suggestions={origenReserva}
                                        value={value}
                                        withChevron
                                        inputTextConfig={{
                                            label: "Origen de reserva",
                                            placeholder: "Selecciona el origen de reserva",
                                            type: "text",
                                            icon: book2Fill,
                                            error: !!errors.origenReserva,
                                            errorhinttext: errors.origenReserva
                                                ? "Selecciona un origen de reserva"
                                                : "",
                                        }}
                                        onChange={(data) => {
                                            onChange(data)
                                        }}
                                        displaySuggestions={origenFiltroVisual}
                                    />
                                )}
                            />

                            <Controller
                                name="codigoReserva"
                                control={control}
                                rules={{ required: codigoReservaRequired }}
                                render={({ field: { onChange, value } }) => (
                                    <InputText
                                        value={value}
                                        toolTipInfo={true}
                                        icon={iconHash}
                                        tooltipInput={{
                                            title: "¿Dónde lo encuentro?",
                                            theme: "dark",
                                            description:
                                                "Es el código de confirmación generado desde otras plataformas de reserva (Ej. Expedia, etc).",
                                        }}
                                        placeholder="Ingresa el código de reserva"
                                        onChange={(value) => onChange(value)}
                                        label={"Código de reserva"}
                                        type={"text"}
                                        error={!!errors.codigoReserva}
                                        errorhinttext={"El código de reserva es requerido"}
                                    />
                                )}
                            />
                        </div>
                        <div className="registro-reservas__form__room__tipeRoom">
                            <p className="registro-reservas__form__room__tipeRoom__title">Tipo de habitación</p>
                            <div className="registro-reservas__form__room__tipeRoom__item">
                                <Controller
                                    control={control}
                                    rules={{ required: true }}
                                    name="tipoDeHabitacion"
                                    render={({ field: { value, onChange } }) => (
                                        <>
                                            {habitacionesFiltradas.map((tipo) => (
                                                <MiniRoomTypeCard
                                                    key={uuid()}
                                                    people={Number(tipo.personas_incluidas)}
                                                    extra={2}
                                                    selected={value.id === String(tipo.tipo_habitacion_id)}
                                                    roomTypeName={tipo.nombre}
                                                    setSelected={() => {
                                                        if (!tipo.desactivar) {
                                                            maxPersonas(tipo.personas_incluidas)
                                                            setValue(
                                                                "cantidadPersonas",
                                                                Number(tipo.personas_incluidas)
                                                            )
                                                            onChange({
                                                                id: tipo.tipo_habitacion_id,
                                                                nombre: tipo.nombre,
                                                            })
                                                        }
                                                    }}
                                                    disabled={tipo.desactivar}
                                                />
                                            ))}
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="registro-reservas__form__room__tarifa">
                            <Controller
                                name="tarifas"
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange }, fieldState: { error } }) => (
                                    <MultipleSelectDropdown
                                        options={opciones_tarifas_hotel.map((item) => ({
                                            ...item,
                                            available: item.modalidad !== "base",
                                        }))}
                                        errorHintText={
                                            !tipoDeHabitacion?.id || !fechaReserva?.length
                                                ? ""
                                                : error
                                                ? "Selecciona una opción"
                                                : ""
                                        }
                                        icon={"dollarCircle"}
                                        onChange={(currentValue, lastItem) => {
                                            const values = getUpdatedTarifasSelection(value, currentValue, lastItem ?? "", opciones_tarifas_hotel)
                                            onChange(values)
                                        }}
                                        value={value}
                                        staticShowLabel={`Tarifa base${new Set(value).size > 1 ? ` + ${new Set(value).size - 1} tarifa(s)` : ""}`}
                                        placeholder="Selecciona una opción"
                                        label="Tarifa base o temporadas"
                                        disabled={!tipoDeHabitacion?.id || !fechaReserva?.length}
                                    />
                                )}
                            />
                            <Controller
                                name="tarifasAdicionales"
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange }, fieldState: { error } }) => (
                                    <MultipleSelectDropdown
                                        className="tarifas-adicionales-dropdown"
                                        options={opciones_tarifas_adicionales}
                                        errorHintText={error ? "Selecciona una opción" : ""}
                                        icon={"dollarCircle"}
                                        onChange={(currentValue, lastItem) => {
                                            const values = getUpdatedTarifasSelection(value, currentValue, lastItem ?? "", opciones_tarifas_adicionales)
                                            onChange(values)
                                        }}
                                        value={value}
                                        staticShowLabel={`${value.length > 1 ? `+ ${value.length} tarifas` : ""}`}
                                        placeholder="Selecciona una opción"
                                        label="Tarifas adicionales (opcional)"
                                        disabled={!tipoDeHabitacion?.id || !fechaReserva?.length}
                                    />
                                )}
                            />
                        </div>
                        <div className="counter-section-form">
                            <div className="counter-section-form__column1">
                                <Controller
                                    name="cantidadPersonas"
                                    control={control}
                                    rules={{ required: true, min: 1, max: numMaxPersonas }}
                                    render={({ field: { onChange, value } }) => (
                                        <Counter
                                            label="Personas"
                                            max={numMaxPersonas}
                                            onClick={(lvalue) => {
                                                if (valueNumPersonasExtra > 0 && lvalue < value) {
                                                    setValue(
                                                        "cantidadPersonasExtra",
                                                        reserva?.reservaIdSaved
                                                            ? reserva?.cantidadPersonasExtra
                                                            : valueNumPersonasExtra - 1
                                                    )
                                                    onChange(value)
                                                } else {
                                                    onChange(lvalue)
                                                }
                                            }}
                                            value={value}
                                            errorHintText={errors.cantidadPersonas ? "El campo es requerido" : ""}
                                            min={0}
                                            className="registro-reservas__form__counter"
                                            disable={
                                                (!!reserva?.reservaIdSaved || valueNumPersonas === 0) &&
                                                totalPersonas >= numMaxPersonas
                                            }
                                        />
                                    )}
                                />
                                <Controller
                                    name="cantidadPersonasExtra"
                                    control={control}
                                    rules={{ required: true, min: valueMinNumPersonasExtra, max: personasExtraMax }}
                                    render={({ field: { onChange, value } }) => (
                                        <Counter
                                            label="Personas extra"
                                            value={value}
                                            max={personasExtraMax}
                                            textLimit={"Máximo de personas por habitación alcanzado*"}
                                            onClick={(lvalue) => {
                                                if (reserva?.reservaIdSaved) {
                                                    if (lvalue >= valueMinNumPersonasExtra) {
                                                        onChange(lvalue)
                                                    }
                                                } else {
                                                    if (valueNumPersonas >= numMaxPersonas) {
                                                        onChange(lvalue)
                                                    } else if (lvalue > (value || 0)) {
                                                        setValue("cantidadPersonas", valueNumPersonas + lvalue)
                                                    }
                                                }
                                            }}
                                            min={valueMinNumPersonasExtra}
                                            className="registro-reservas__form__counter"
                                            disable={!personaExtraEnabled || (valueNumPersonas === 0 && totalPersonas >= numMaxPersonas)}
                                        />
                                    )}
                                />
                            </div>
                            <div className="counter-section-form__column2">
                                <Controller
                                    name="experiencias"
                                    control={control}
                                    render={({ field: { value = [], onChange } }) => {
                                        const opcionesModificadas =
                                            data?.experiencias?.map((exp) => {
                                                const precioLabel =
                                                    exp.precio >= 0 ? (
                                                        <span style={{ fontWeight: 600, color: "black" }}>
                                                            ${exp.precio}
                                                        </span>
                                                    ) : (
                                                        <span style={{ fontWeight: 600, color: "red" }}>
                                                            -${Math.abs(exp.precio)}
                                                        </span>
                                                    )
                                                return {
                                                    value: exp.experiencia_id,
                                                    label: `${exp.nombre} ${exp.precio}`,
                                                    precio: <>{exp.nombre} {precioLabel}</>,
                                                    withCheckbox: true,
                                                    checked: value.includes(exp.experiencia_id),
                                                    available: !experienciasSaved.includes(exp.experiencia_id),
                                                    showInLabelOnSelected: true,
                                                }
                                            }) || []
                                        return (
                                            <MultipleSelectDropdown
                                                label={"Experiencias (Opcional)"}
                                                placeholder={"Selecciona una opción"}
                                                icon={"giftFill"}
                                                onChange={(selectedValues) => {
                                                    const nuevasExperiencias = selectedValues.filter(
                                                        (id) => !experienciasSaved.includes(id)
                                                    )
                                                    onChange([...experienciasSaved, ...nuevasExperiencias])
                                                }}
                                                value={value || []}
                                                options={opcionesModificadas}
                                                editReserva={true}
                                                allowDeselectWhenMax={true}
                                            />
                                        )
                                    }}
                                />
                            </div>
                        </div>
                        <div className="registro-reservas__form__room__button__cont">
                            <Button
                                type={"submit"}
                                text="Continuar"
                                className="registro-reservas__form__room__button__cont__button"
                            />
                        </div>
                    </div>
                    <LoaderComponent visible={loader} />
                    <AlertReservas
                        visible={alerta.visible}
                        date={alerta.date}
                        onClose={() => {
                            setAlerta({ visible: false, date: "" })
                            setValue("fechaReserva", [])
                            setCalendarLoad(true)
                            setTimeout(() => setCalendarLoad(false), 1000)
                        }}
                        onConfirm={() => {
                            setAlerta({ visible: false, date: "" })
                            onSuccess(getValues())
                        }}
                    />
                </form>
                <CancelReservaModal
                    isOpen={isCancelModalOpen}
                    isEditMode={!!reservaIdSaved}
                    onClose={() => setIsCancelModalOpen(false)}
                />
            </section>
        </Screen>
    )
}

export default ReservaFormularioInicial
